import { render } from "./AboutDescription.vue?vue&type=template&id=4f4f63b3"
import script from "./AboutDescription.vue?vue&type=script&lang=js"
export * from "./AboutDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__